import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useModuloSecaoService() {
  const { authenticatedFetch } = useApi();

  const criarSecao = async (dados) => {
    // dados esperados:
    // {
    //   idModulo: string (hash),
    //   titulo: string,
    //   descricao?: string,
    //   ordem?: number
    // }
    const response = await authenticatedFetch(URLS.CREATE_MODULO_SECAO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const atualizarSecao = async (dados) => {
    // dados esperados:
    // {
    //   id: string (hash),
    //   idModulo: string (hash),
    //   titulo: string,
    //   descricao?: string,
    //   ordem?: number
    // }
    const response = await authenticatedFetch(URLS.UPDATE_MODULO_SECAO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const deletarSecao = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_MODULO_SECAO, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarSecoes = async () => {
    // moduloSecaoRead.php não exige body, mas seguimos padrão POST com {}
    const response = await authenticatedFetch(URLS.READ_MODULO_SECAO, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    return response.json();
  };

  const obterSecaoPorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_MODULO_SECAO_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarSecoesPorModulo = async (idModulo) => {
    // idModulo: hash do módulo
    const response = await authenticatedFetch(URLS.READ_MODULO_SECAO_BY_MODULO, {
      method: 'POST',
      body: JSON.stringify({ idModulo }),
    });

    return response.json();
  };

  return {
    criarSecao,
    atualizarSecao,
    deletarSecao,
    listarSecoes,
    obterSecaoPorId,
    listarSecoesPorModulo,
  };
}